module.exports = __webpack_public_path__ + "img/charge.b467bc5b.png";